import { render, staticRenderFns } from "./TariffCalculatorDot.vue?vue&type=template&id=52d75094&"
import script from "./TariffCalculatorDot.vue?vue&type=script&lang=ts&"
export * from "./TariffCalculatorDot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports